import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICKYCState {
  ckycNumber: string
  ckycStatus: string
  identityNumber: string
  identityType: string
  documentType: string
  documentValue: string
  document: File | null
  ckycHash: string
  insurerExtraData: any
  selectedDOB: string
  selectedType: 'pan' | 'ckyc' | 'others' | 'cin' | ''
  selectedOtherType: string
  customerName: string
  fatherName: string
  isOvdUploaded: boolean
}

const initialState: ICKYCState = {
  ckycNumber: '',
  ckycStatus: '',
  identityNumber: '',
  identityType: '',
  documentType: '',
  documentValue: '',
  document: null,
  ckycHash: '',
  insurerExtraData: null,
  selectedDOB: '',
  selectedType: '',
  selectedOtherType: '',
  customerName: '',
  fatherName: '',
  isOvdUploaded: false,
}

const ckycSlice = createSlice({
  name: 'ckyc',
  initialState: initialState,
  reducers: {
    resetCkyc: () => initialState,
    updateCkycDetails: (
      state,
      action: PayloadAction<{
        ckycNumber?: string
        ckycStatus?: string
        identityNumber?: string
        identityType?: string
        documentType?: string
        documentValue?: string
        document?: File | null
        ckycHash?: string
        insurerExtraData?: any
        selectedDOB?: string
        selectedType?: 'pan' | 'ckyc' | 'others' | 'cin'
        selectedOtherType?: string
        customerName?: string
        fatherName?: string
        isOvdUploaded?: boolean
      }>,
    ) => {
      const {
        ckycHash,
        ckycNumber,
        ckycStatus,
        documentType,
        documentValue,
        identityNumber,
        identityType,
        insurerExtraData,
        selectedDOB,
        selectedType,
        selectedOtherType,
        customerName,
        fatherName,
        isOvdUploaded,
      } = action.payload
      if (ckycHash) state.ckycHash = ckycHash
      if (ckycNumber) state.ckycNumber = ckycNumber
      if (ckycStatus) state.ckycStatus = ckycStatus
      if (documentType) state.documentType = documentType
      if (documentValue) state.documentValue = documentValue
      if (identityNumber) state.identityNumber = identityNumber
      if (identityType) state.identityType = identityType
      if (insurerExtraData) state.insurerExtraData = insurerExtraData
      if (selectedDOB) state.selectedDOB = selectedDOB
      if (selectedType) state.selectedType = selectedType
      if (selectedOtherType) state.selectedOtherType = selectedOtherType
      if (customerName) state.customerName = customerName
      if (fatherName) state.fatherName = fatherName
      if (typeof isOvdUploaded === 'boolean') state.isOvdUploaded = isOvdUploaded
    },
  },
})

const { reducer } = ckycSlice

const { resetCkyc, updateCkycDetails } = ckycSlice.actions

export { reducer as ckycReducer, resetCkyc, updateCkycDetails }
